import { Button, Result } from 'antd';
import React from 'react';
import Logo from '../assets/logo-sarovar.svg';
import { useNavigate } from 'react-router-dom';
import { HOTELS_IMAGE_ROOT_URL } from '../constant';
import { useHotel } from '../context/HotelContext';

const Thankyou = () => {
    const navigate = useNavigate();
    const { hotelDetails } = useHotel();

    return (
        <div className='bg-img min-h-dvh flex flex-col justify-center items-center'>
            <div className='logo-splash'>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTELS_IMAGE_ROOT_URL}${hotelDetails.logo}`}
                        alt='logo'
                        className='max-w-32 md:max-w-60'
                        onClick={() => navigate('/', { replace: true })}
                    />
                )}
            </div>
            <div>
                <Result
                    status='success'
                    title='Details Submitted Successfully!'
                    extra={[
                        <Button
                            type='primary'
                            key='console'
                            size='large'
                            className='btn-gradient  rounded-full px-12 min-h-12 bg-blue-400 text-white mb-4'
                            onClick={() => navigate('/', { replace: true })}
                        >
                            Go to Home page
                        </Button>,
                        <Button
                            key='buy'
                            size='large'
                            className='submitbtn  rounded-full px-12 min-h-12 bg-white text-black'
                            onClick={() => navigate(-1)} // Go back to the last page
                        >
                            Add More Guests
                        </Button>
                    ]}
                />
            </div>
        </div>
    );
};

export default Thankyou;
